module.exports = __webpack_public_path__ + "static/media/Bus_Express_660x288px.9cad04cc.jpg";